import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

import { wpApiInstance } from '@/lib/wp-api.service';
import { Alert } from '@/types/alert';
import CriticalAlert from '@/widgets/Alerts/CriticalAlert';

const AlertsContainer = () => {
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const [hiddenIds, setHiddenIds] = useState<Set<number>>(new Set());

  useEffect(() => {
    wpApiInstance.get<Alert[]>('/ekt-homepage/v1/warning-messages').then((response) => {
      if (Array.isArray(response.data)) {
        setAlerts(response.data);
      }
    });
  }, []);

  const visibleAlerts = alerts.filter(
    (alert) => dayjs().isAfter(alert.start_time) && dayjs().isBefore(alert.expire_time) && !hiddenIds.has(alert.id),
  );

  const handleAlertClose = (id: number) => {
    setHiddenIds((ids) => new Set(ids).add(id));
  };

  if (visibleAlerts.length === 0) {
    return <></>;
  }

  return (
    <div className="lg:px-8 py-5 sm:px-6 px-3 flex flex-col gap-4">
      {visibleAlerts.map((alert) => (
        <CriticalAlert key={alert.id} id={alert.id} title={alert.title} message={alert.message} onClose={handleAlertClose} />
      ))}
    </div>
  );
};

export default AlertsContainer;
